<!--
  ~ Copyright (c) 2019 Signum+ Software & Facility GmbH
  ~ Author: jahn@signum-plus.at
  -->

<ng-container *ngIf="model && model.content" [kitComponent]="model.content"></ng-container>